import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";

import { AutorizzazioneDTO } from "@app/shared/dto/autorizzazioneDTO";
import { AutorizzazioneVO } from "@app/shared/vo/autorizzazioneVO";

@Injectable({
  providedIn: "root"
})
export class MapperAutorizzazione
  implements MapperInterface<AutorizzazioneDTO, AutorizzazioneVO> {
  constructor() { }

  convertVoToDto(autorizzazioneVO: AutorizzazioneVO): AutorizzazioneDTO {
    // console.log("[MapperAutorizzazione] AutorizzazioneVO => AutorizzazioneDTO");
    const autorizzazioneDTO = new AutorizzazioneDTO();

    autorizzazioneDTO.codice = autorizzazioneVO.codice;
    autorizzazioneDTO.nome = autorizzazioneVO.nome;

    return autorizzazioneDTO || new AutorizzazioneDTO();
  }

  convertDtoToVo(autorizzazioneDTO: AutorizzazioneDTO): AutorizzazioneVO {
    // console.log("[MapperAutorizzazione] AutorizzazioneDTO => AutorizzazioneVO");
    const autorizzazioneVO = new AutorizzazioneVO();

    autorizzazioneVO.nome = autorizzazioneDTO.nome;
    autorizzazioneVO.codice = autorizzazioneDTO.codice;

    return autorizzazioneVO || new AutorizzazioneVO();
  }

  convertListVoToDto(
    autorizzazioneVOList: AutorizzazioneVO[]
  ): AutorizzazioneDTO[] {
    /* console.log(
      "[MapperAutorizzazione] autorizzazioneDTOList => autorizzazioneVOList"
    ); */

    const autorizzazioneDTOList = new Array<AutorizzazioneDTO>();
    autorizzazioneVOList.forEach(vo => {
      autorizzazioneDTOList.push(this.convertDtoToVo(vo));
    });

    return autorizzazioneDTOList || new Array<AutorizzazioneDTO>();
  }

  convertListDtoToVo(
    autorizzazioneDTOList: AutorizzazioneDTO[]
  ): AutorizzazioneVO[] {
    /* console.log(
      "[MapperDocumenti] autorizzazioneVOList => autorizzazioneDTOList"
    ); */

    const autorizzazioneVOList = new Array<AutorizzazioneVO>();
    autorizzazioneDTOList.forEach(dto => {
      autorizzazioneVOList.push(this.convertDtoToVo(dto));
    });

    return autorizzazioneVOList || new Array<AutorizzazioneVO>();
  }
}
